import * as React from 'react'
import { useMemo } from 'react'
import Card from '@mui/material/Card'
import Slide from '@mui/material/Slide'
import Box from '@mui/material/Box/Box'
import Button from '@mui/material/Button'
import useMediaQuery from '@mui/material/useMediaQuery'
import Typography from '@mui/material/Typography'
import { SearchDrawerContents } from './SearchDrawerContents/SearchDrawerContents'
import { HereResult } from '@user/store/services/hereGeoCoder'

type Props = {
  show: boolean
  onClose: () => void
  drawerVariant?: 'full' | 'modal'
  toolbarWidth: number
  map: H.Map | null
  onFoundLocation: () => void
  onPanToLocation?: (result: HereResult) => Promise<void>
}

function SearchDrawer(props: Props): JSX.Element {
  const {
    onClose,
    show,
    drawerVariant = 'full',
    toolbarWidth,
    onFoundLocation,
  } = props

  const isFullVariant = React.useMemo(
    () => drawerVariant === 'full',
    [drawerVariant],
  )

  const isMobile = useMediaQuery('(max-width: 600px)')

  const { left, top } = useMemo(() => {
    if (isFullVariant) {
      return {
        left: isMobile ? 0 : toolbarWidth,
        top: isMobile ? '64px' : 0,
      }
    }

    return {
      left: 24,
      top: 96,
    }
  }, [isFullVariant, isMobile, toolbarWidth])

  return (
    <Slide direction="right" in={show} mountOnEnter unmountOnExit>
      <Card
        sx={{
          height: isFullVariant ? `100%` : 'fit-content',
          width: isMobile ? '100vw' : 400,
          position: 'fixed',
          top,
          left,
          zIndex: 1300,
          boxShadow: 4,
          borderRadius: isFullVariant ? undefined : 3,
          overflowY: 'auto',
          paddingTop: 1,
          paddingBottom: isMobile ? 10 : 2,
        }}
      >
        <Box
          sx={{
            paddingLeft: 3,
            paddingRight: 2,
            pb: 1.5,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="subtitle4">Search</Typography>
            <Button
              variant="text"
              aria-label="close"
              onClick={onClose}
              sx={{ color: '#1565C0', minWidth: 0, width: 'fit-content' }}
              size="small"
            >
              Close
            </Button>
          </Box>
        </Box>
        <SearchDrawerContents
          map={props.map}
          onClose={onClose}
          onFoundLocation={onFoundLocation}
          onPanToLocation={props.onPanToLocation}
        />
      </Card>
    </Slide>
  )
}

export default SearchDrawer
